import type { UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { ElasticVehiclesResponse } from '@//app/api/search/vehicles';
import { useLegacyTrackSearch } from '@//data/tracking/useLegacyTrackSearch';

interface UseTrackSearchProps {
  vehiclesQuery: UseQueryResult<ElasticVehiclesResponse, Error>;
  vehicleSearchParams: URLSearchParams;
}

const useTrackSearch = ({ vehiclesQuery, vehicleSearchParams }: UseTrackSearchProps) => {
  const { trackLegacySearch } = useLegacyTrackSearch();
  useEffect(() => {
    if (
      vehiclesQuery.isSuccess &&
      vehiclesQuery.data &&
      vehicleSearchParams.toString() &&
      !vehiclesQuery.isFetching
    ) {
      trackLegacySearch({
        urlParameters: vehicleSearchParams.toString(),
        searchData: {
          searchEngineRoundTripTimeInMillis:
            vehiclesQuery.data.stats.searchEngineRoundTripTimeInMillis,
          searchEngineTimeInMillis: vehiclesQuery.data.stats.searchEngineTimeInMillis,
          searchProcessingTimeInMillis: vehiclesQuery.data.stats.searchProcessingTimeInMillis,
          sortOption:
            vehiclesQuery.data.documentList.sortOptions.find((o) => o.selected)?.query || '',
          totalHits: vehiclesQuery.data.stats.totalHits,
        },
      });
    }
  }, [vehiclesQuery.isSuccess, vehicleSearchParams.toString(), vehiclesQuery.isFetching]);
};

export default useTrackSearch;
